import { type ResponseMESF } from "@dexteel/mesf-core";
import { Box, Paper } from "@mui/material";
import { AgGridReact } from "ag-grid-react";
import { CenteredLazyLoading } from "../../../../../../controls/LazyLoading";
import { AgGridFooterActions } from "../../../../../../shared/data-entries/AgGridFooterActions";
import { useDataEntryContext } from "../../../context/reducer.provider";
import { useTimerContext } from "../../../context/timer.provider";
import { useLMFDataEntryActions } from "../../../hooks/useLMFDataEntryActions";
import { readHeatingsFromPLC } from "../../../repositories/lmf.repositories";
import { useTheme } from "@mui/material/styles";
import { lmfDETablesStyles } from "../styles/lmfDETablesStyles";
import { useTableData } from "./hooks/useHeatingsTableData";
import { defaultColDef, defaultGridOptions } from "@/setup/ag-grid/mesf-theme";

export const TableHeatings = () => {
  const {
    state: { deProcess },
    actions: { setNotificationMessage, setErrorMessage },
  } = useDataEntryContext();
  const { refreshData } = useLMFDataEntryActions();
  const { pause, resume } = useTimerContext();

  const heatings = deProcess?.heatings;
  const theme = useTheme();
  const styles = lmfDETablesStyles(theme);

  const { columns } = useTableData();

  const readAutomaticHeatings = async (value?: string) => {
    if (value === "OK") {
      const resp = await readHeatingsFromPLC({
        ProcessId: deProcess!.process!.ProcessId,
      });
      if (resp.ok) {
        setNotificationMessage("Read heatings from PLC successful");
        await refreshData();
        return resp as ResponseMESF;
      } else {
        setErrorMessage(resp.message);
        return {
          ok: false,
          message: "Read heatings from PLC failed",
        } as ResponseMESF;
      }
    } else {
      return {} as ResponseMESF;
    }
  };

  return (
    <>
      <Paper>
        <Box padding={1} sx={styles.agGridBox}>
          <AgGridReact
            rowData={heatings}
            columnDefs={columns}
            defaultColDef={{ ...defaultColDef, sortable: false }}
            loadingOverlayComponent={CenteredLazyLoading}
            {...defaultGridOptions}
          />
          <AgGridFooterActions
            show={{ new: false, plc: true }}
            readFromPLC={readAutomaticHeatings}
            table="heatings"
            pause={pause}
            resume={resume}
          />
        </Box>
      </Paper>
    </>
  );
};
